export default {
    controlSupplier: {
        name: '请输入承运商',
        advanceLabel: '承运商',
        value: 'carrierName',
        advanceConfig: [
            { prop: 'supplierNameCn', value: '承运商名称' },
            { prop: 'supplierCode', value: '承运商编码' }
        ],
        tableConfig: [
            { prop: 'supplierNameCn', value: '承运商名称' },
            { prop: 'supplierCode', value: '承运商编码' }
        ],
        advanceNotSearch: true,
        queryConditionRequired: true,
        method: 'post',
        prefix: '/api-tms',
        advanceUrl: '/srm/supplier/search',
        cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode'],
        advanceCascade: 'carrierCode#supplierCode'
    },
    // 车牌
    controlVehicleCard: {
        method: 'post',
        name: '请输入车牌号',
        advanceLabel: '车牌号',
        value: 'vehicleCard',
        advanceConfig: [
            { prop: 'licensePlateNo', value: '车牌' },
            { prop: 'maxVolume', value: '载货体积' },
            { prop: 'carTypeNameCn', value: '车型' },
            { prop: 'carType', value: '车型编码' }
        ],
        tableConfig: [
            { prop: 'licensePlateNo', value: '车牌' },
            { prop: 'maxVolume', value: '载货体积' },
            { prop: 'carTypeNameCn', value: '车型' },
            { prop: 'carType', value: '车型编码' }
        ],
        cbParams: ['licensePlateNo#vehicleCard', 'maxVolume#cargoVolumeStr', 'carTypeNameCn#equipmentName', 'carType#equipmentType', 'deviceNo'],
        prefix: '/api-srm-web/',
        advanceUrl: 'basis/supplierCarInfos/getEnableCarListBySupplierCode',
        advanceCascade: 'carrierCode#supplierCode'
    },
    // 司机
    controlDriver: {
        method: 'post',
        name: '请输入司机',
        advanceLabel: '司机',
        value: 'driver',
        advanceConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        tableConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        prefix: '/api-srm-web/',
        advanceUrl: 'basis/supplierDriverInfo/getEnableDriverListBySupplierCode',
        cbParams: ['driverName#driver', 'driverPhone#driverContactWay', 'driverIdCard#driverIdentity', 'onWayContactCategory', 'onWayContactName', 'onWayContactPhone', 'driverCode#driverNo'],
        advanceCascade: 'carrierCode#supplierCode'
    }
};
